import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'training-types';

const TrainingTypeService = {
  getList() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
};

export default TrainingTypeService;
